import React, { useState, useEffect } from "react";
import PropTypes from "prop-types"; //  Import PropTypes
import * as Icon from 'react-feather';
import { Link } from "react-router-dom";
import SuperBiodataCard from "../layouts/SuperBiodataCard";
import { useTranslation } from 'react-i18next';


const AllBiodataMobile = ({activeTab,handlePageChange, currentPage, nextPage, prevPage, count, data}) => {
  const { t } = useTranslation();
  
  return (
    <>
      {data.length > 0 ? (
        data.map((item, index) => (
          <div key={index} className="rounded mb-3 text-dark">

            <SuperBiodataCard activeTab={activeTab} item={item} />

            
          </div>
        
        ))
      ) : (
        <div className="p-3 rounded bg-white text-secondary mb-3">
          <p>No Data</p>
        </div>
      )}

 {/* Pagination Controls */}
      <div className="mt-3">
        <button
          className="btn btn-secondary me-2"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          {t("Previous")}
        </button>
        <span>{t("Page")} {currentPage} {t("of")} {Math.ceil(count / 10)}</span>
        <button
          className="btn btn-secondary ms-2"
          onClick={() => handlePageChange(currentPage + 1)}
        >
          {t("Next")}
        </button>
      </div>
    </>
  )
}

AllBiodataMobile.propTypes = {
  user: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  vendorId: PropTypes.number.isRequired,
  clickedBiodata: PropTypes.func.isRequired,
  setSelectedBiodata: PropTypes.func.isRequired,
  selectedBiodata: PropTypes.object,
  onRefresh: PropTypes.func.isRequired,
  screenWidth: PropTypes.number.isRequired,

  handlePageChange: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  nextPage: PropTypes.func.isRequired,
  prevPage: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  activeTab: PropTypes.string.isRequired
};

export default AllBiodataMobile